import { render, staticRenderFns } from "./Pollstar copy 3.vue?vue&type=template&id=ec131074&scoped=true&"
import script from "./Pollstar copy 3.vue?vue&type=script&lang=js&"
export * from "./Pollstar copy 3.vue?vue&type=script&lang=js&"
import style0 from "./Pollstar copy 3.vue?vue&type=style&index=0&id=ec131074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec131074",
  null
  
)

export default component.exports